$(document).ready(function(){
$('.cstm-main-testimonial-slick-slide').slick({
  dots: false,
  infinite: true,
  speed: 300,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
// prevArrow: '<i class="fa-sharp fa-solid fa-arrow-left"></i>',
// nextArrow: '<i class="fa-sharp fa-solid fa-arrow-right"></i>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});




 $('.featured_main_image').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.featured_thumb_nail_image'
});
$('.featured_thumb_nail_image').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.featured_main_image',
  dots: false,
  arrows: true,
  centerMode: false,
  focusOnSelect: true
});
		

  $('body').on('click', '.quantity__button', function () {
    $(this).closest('.cart-item__quantity').find('.quantity__input').css('opacity', '0');
  })
});

